import { AcceptAICapTableModalProps } from './AcceptAICapTableModal.props';
import { acceptAllButtonSx } from './AcceptAICapTableModal.styles';
import AICapTableBulkActionModal from './AICapTableBulkActionModal';

const AcceptAICapTableModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}: AcceptAICapTableModalProps) => (
  <AICapTableBulkActionModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    isSubmitting={isSubmitting}
    title="Accept AI Generated Cap Table"
    contentId="accept-ai-captable-modal-content"
    bodyText="This will accept all AI-suggested values across the cap table."
    helperText="You can still manually adjust individual cells after accepting. This action cannot be undone in bulk."
    confirmText="Accept All"
    submittingText="Accepting…"
    confirmButtonSx={acceptAllButtonSx}
    cancelTestId="accept-ai-captable-modal-cancel"
    confirmTestId="accept-ai-captable-modal-confirm"
  />
);

export default AcceptAICapTableModal;
